import React, { useRef, useLayoutEffect } from 'react';
import styled from 'styled-components';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import ImgImp from '../assets/innovation.png';

gsap.registerPlugin(ScrollTrigger);

const PageContainer = styled.div`
  background-color: black;
  color: #fff;
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  @media (min-width: 1500px) {
    min-height: auto;
  }
  @media only screen and (min-device-width: 900px)and (max-device-width: 1024px) {
    min-height: auto;
    margin-top:15%;
 }
`;

const TitleWrapper = styled.div`
  overflow: hidden;
  height: 270px;
  width: 100%;

  @media (max-width: 900px) {
    height: 10rem;
  }
`;

const Title2 = styled.p`
  font-size: 8rem;
  color: #fff;
  font-family: 'MongoGrotesqueLight';
  margin: 0;

  @media (max-width: 900px) {
    font-size: 5rem;
    text-align: center;
    width: 100%;
  }
  @media (max-width: 410px) {
    font-size: 4rem;
    text-align: center;
    width: 100%;
  }
  
`;

const ContentRow = styled.div`
  display: flex;
  flex-direction: row;
  width: 85%;
  margin-left: 10%;
  align-items: center;
  justify-content: space-between;
  @media (min-width: 1500px) {
    justify-content: center;
    width: 100%;
    gap:50px;
    margin-left: 0%;
  }
  @media only screen and (min-device-width: 900px)and (max-device-width: 1024px) {
    margin-left: 2%;
    gap:30px;
    width: 95%;
 }
  @media (max-width: 900px) {
    flex-direction: column;
    width: 100%;
    margin: 0 auto;
    align-items: center;
    text-align: center;
  }
`;

const ContentCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: left;
  
  @media (max-width: 900px) {
    width: 90%;
    text-align: left;
    align-items: center;
    margin-top: 2rem;
  }
`;

const ContentImage = styled.img`
  width: 450px;
  margin-bottom: 1rem;

  @media (max-width: 900px) {
    display: none;
  }
`;

const ContentImageMob = styled.img`
  display: none;

  @media (max-width: 900px) {
    width: 350px;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 400px;
    margin-bottom: 2rem;
    margin-top: 2rem;
  }
`;

const ContentSubtitle = styled.p`
  margin: 0;
  font-size: 1rem;
  color: #ccc;
`;

const Innovation: React.FC = () => {
  const titleRef = useRef<HTMLParagraphElement>(null);

  useLayoutEffect(() => {
    if (!titleRef.current) return;

    gsap.set(titleRef.current, { yPercent: 100 });

    gsap.to(titleRef.current, {
      yPercent: 0,
      duration: 1,
      ease: 'power4.out',
      delay: 0.2,
      scrollTrigger: {
        trigger: titleRef.current,
        start: 'top 80%',
        toggleActions: 'play none none none',
      },
    });
  }, []);

  return (
    <PageContainer>
      <ContentRow>
        <ContentCard>
          <TitleWrapper>
            <Title2 ref={titleRef}>
              L'INNOVATION AU SERVICE
              <br />
              DU DIVERTISSEMENT
            </Title2>
          </TitleWrapper>
          <ContentImageMob src={ImgImp} alt="Illustration" />
          <ContentSubtitle>
            En mars 2023, Partouche Multiverse a lancé Joker Club,<br />
            sa toute première collection NFT : 4 444 Jokers uniques sur la blockchain Ethereum,<br />
            incarnant une nouvelle vision du divertissement. Le Joker Club,<br />
            c’est bien plus qu’une collection : c’est une communauté 3.0 en marche vers un avenir décentralisé.<br />
            Ici, le divertissement est sacré, le Joker est vénéré,<br />
            et chaque NFT ouvre l’accès à des avantages exclusifs au sein de l’écosystème Partouche<br />
            et auprès de ses partenaires. Le mouvement est lancé. Le temps du Joker Spirit est arrivé.
          </ContentSubtitle>
        </ContentCard>

        <ContentImage src={ImgImp} alt="Illustration" />
      </ContentRow>
    </PageContainer>
  );
};

export default Innovation;